import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { TranslateModule } from '@ngx-translate/core';
import { CoreCommonModule } from '@core/common.module';
import { AdminGuard } from 'app/common/guards/admin.guard';
import { HomeComponent } from './home/home.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ImagePreviewComponent } from './shared/image-preview/image-preview.component';
import { BranchFormComponent } from './admin/administration/branch/branch-form/branch-form.component';
import { BranchModule } from './admin/administration/branch/branch.module';
import { ApkService, BranchService } from 'app/be-api';
import { AuthGuard } from 'app/common/guards/auth.guard';
import { DownloadApkComponent } from './download-apk/download-apk.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'error',
    loadChildren: () => import('./error/error.module').then(m => m.ErrorModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [AdminGuard,AuthGuard],
  },
  {
    path: 'download-apk',
  component: DownloadApkComponent,
  },
  // {
  //   path: 'dashboard',
  //   loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  // },
  // {
  //   path: 'home',
  //   component: HomeComponent
  // },
];

@NgModule({
  declarations: [
    HomeComponent,
    ImagePreviewComponent,
    DownloadApkComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    TranslateModule,
    CoreCommonModule,
  ],
  providers: [ ApkService
   ]
})
export class MainModule { }
